import { useTransientDiRef } from '@/common/react/di-hooks'
import type { ObjectTypeModel } from '@/core/gql/gql-models-override.ts'
import { CreateObjectController } from './CreateObjectController'
import { ObjectFormPage } from '../object-form/ObjectFormPage'

export interface CreateObjectPageProps {
  type: ObjectTypeModel
  closePopover: () => void
}

export default function CreateObjectPage({ type, closePopover }: CreateObjectPageProps) {
  const controller = useTransientDiRef<CreateObjectController>(
    'CreateObjectController',
    (c) => { c.init(type, closePopover) },
  )

  return <ObjectFormPage label={`Create a new ${type.name}:`} controller={controller} />
}
